import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("canvas", {
    ref: "chart",
    width: $props.width,
    height: $props.height
  }, null, 8, _hoisted_1);
}